import { F } from './fancybox-BA187ItQ.js';

class ProductMedia extends HTMLElement {
  connectedCallback() {
    this.#initFancybox();
  }

  #initFancybox() {
    F.bind('[data-fancybox]', {
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
        Lazyload: true,
      },
    });
  }
}

customElements.define('product-media', ProductMedia);
